import { render, staticRenderFns } from "./ApprovalsTab.vue?vue&type=template&id=5a4bea4a"
import script from "./ApprovalsTab.vue?vue&type=script&lang=js"
export * from "./ApprovalsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports